

module.exports = {
	/* DatePicker */
	dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
	dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
	dayNamesShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
	monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
	monthNamesShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai','Jun','Jul','Aug','Sep','Okt','Nov','Dez'],

	/* Header Cart */
	"cart": "Warenkorb",
	"product": "Produkt",
	"product_plural": "Produkte",

	/* Header Favs */
	"favorite": "Favorit",
	"favorite_plural": "Favoriten",

	/* Collectible */
	"collectible.results": "Ergebnisse",
	"collectible.of": "von",
	"next": "Weiter",
	"prev": "Zurück",
	"remove": "Entfernen",

	/* SortOrderTemplate */
	sort_auto: "Aktualität",
	sort_stars: "Sterne",
	sort_ratings: "Bewertung",
	sort_price: "Preis",

	/* SidebarTemplate */
	sidebar_more: "Mehr",

	/* result-template */
	result_validated: "Geprüfte Qualität",
	result_book_online: "Online buchen",
	like: "gefällt mir",
	unlike: "gefällt mir nicht mehr",
	result_recommentation: "Weiterempfehlung",
	add_spa_tax: "zzgl. Kurbeitrag",
	recommentation: "Empfehlung",
	zzgl: "zzgl.",
	spatax: "Kurbeitrag",
	item_includes: "inkl. {item}, ",

	breakfast_charge: "Frühstücks-Aufschlag, ",
	halfboard_charge: "Halbpensions-Aufschlag, ",
	fullboard_charge: "Vollpensions-Aufschlag, ",

	/* result-error */
	result_error_title: "Eine Suche ist momentan nicht möglich.",
	result_error_subtitle: "Es gibt Probleme mit ihrer Suchanfrage:",
	reset_search: "Suche zurücksetzen",

	/* no-results */
	searchquery_no_result_title: "Gastgeber ”{searchQuery}“ nicht gefunden",
	searchquery_no_result_match: "Im aktuellen Suchergebnis gibt es diesen Gastgeber nicht.",

	favsonly_empty_title: "Keine Favoriten gefunden",
	favsonly_empty_text: "Sie haben keine Favoriten, die den aktuellen Suchbedingungen entsprechen.",

	/* loader-results */
	loading_text: "Einen Augenblick bitte",

	/* datepicker-item-info */
	datepicker_item_tip: "Tipp: Klicken Sie erst auf den Anreisetag und dann auf den Abreisetag.",
	datepicker_item_selected: "Kalender hebt verfügbare Anreisetage für »{name}« hervor.",

	/* datepicker-controls */
	dp_controls_mode_none: "Ohne",
	dp_controls_mode_exact: "Exakt",
	dp_controls_mode_range: "Flexibel",
	dp_controls_from: "von",
	dp_controls_to: "bis",
	date_to: "bis",

	/* engine/main.js */
	dd_selected_none: "Ohne Zeitraum",
	dd_select_date: "Bitte Zeitraum auswählen",
	dd_select_date_short: "Zeitraum auswählen",

	favorites: "Favoriten",
	one_favorite: "1 Favorit",

	/* FormModel.js / PeopleStructure.js */
	people_any_count: "Beliebige Personenzahl",

	housing_any: "Zimmer / Fewo",
	housing_room: "Zimmer",
	housing_single: "Einzelzimmer",
	housing_double: "Doppelzimmer",
	housing_flat: "Ferienwohnung",
	housing_house: "Ferienhaus / Hütte",
	housing_campsite: "Stellplatz",

	bedroom_count: "Schlafzimmer",
	bedroom: "Schlafzimmer",
	bedrooms: "Schlafzimmer",

	adult: "Erwachsener",
	adults: "Erwachsene",
	no_adults: "keine Erwachsene",

	no_children: "Keine Kinder",
	one_child: "1 Kind",
	children: "Kinder",
	child: "Kind",

	housings: "Unterkünfte",

	/* NightsCompressor.js */
	night: "Nacht",
	nights: "Nächte",
	at_least: "mind.",
	nights_list: "{nights} und {last_item} Nächte",

	/* timetable-template */
	today: "heute",

	/* ratings-template */
	add_rating: "Bewertung abgeben",

	rating_1: "Angebot",
	rating_2: "Sauberkeit",
	rating_3: "Freundlichkeit",
	rating_4: "Weiterempfehlung",

	age: "Alter",
	no_ratings: "Schade, keine Bewertungen gefunden...",

	for_one_week: "für 1 Woche",
	for_two_weeks: "für 2 Wochen",
	for_x_days: "für {days} Tage",

	in_winter: "im Winter",
	in_spring: "im Frühling",
	in_summer: "im Sommer",
	in_autumn: "im Herbst",
	rated_on: "Bewertet am",
	age_range: "{from} bis {to} Jahre",

	"traveled_as_Single": "verreist als Single",
	"traveled_as_Paar": "verreist als Paar",
	"traveled_as_Familie": "verreist als Familie",
	"traveled_as_Freunde": "verreist als des Freunde",

	products_and_services: "Produkte &amp; Leistungen",

	/* DateTime.js */
	no_date: "Kein Zeitraum",
	one_night: "1 Nacht",
	x_nights: "{nights} Nächte",

	/* classes-template */
	item_focused: "Pauschale im Fokus",
	order: "Buchen",
	inquiry: "Anfrage",
	total_price: "Gesamtpreis",
	price_no_query: "Preis abhängig von<br/>Zeitraum und Personenzahl",
	search: "Suchen",
	packages: "Pauschalen",
	package: "Pauschale",

	results_404_title: "Keine Kategorien gefunden",
	results_404_prefix: "Suchparameter ändern oder",
	results_404_link: "ohne Zeitraum suchen",
	price_from: "ab",

	/* cart-items-template */
	cart_empty: "Warenkorb ist leer",
};





/** WEBPACK FOOTER **
 ** /Users/mitch/jsapps/modules/reserva/translate/lang.de.js
 **/